<h2 mat-dialog-title>Generate NACHA — {{ data.taxType }} Filing</h2>

<mat-dialog-content>

  <!-- Warning: some statements already batched -->
  @if (alreadyBatched.length > 0) {
    <div class="warn-banner">
      <strong>{{ alreadyBatched.length }} statement(s)</strong> already included in a previous NACHA batch
      and will be excluded from this file.
    </div>
  }

  @if (eligible.length === 0) {
    <p>All selected statements have already been included in a NACHA batch for {{ data.taxType }}.</p>
  } @else {

    <!-- Filing steps -->
    <h3>Filing Steps</h3>
    <ol class="steps-list">
      @for (step of steps; track step) {
        <li>{{ step }}</li>
      }
    </ol>

    <!-- Summary table -->
    <h3>Properties Included in This File</h3>
    <table class="summary-table">
      <thead>
        <tr>
          <th>Property</th>
          <th>Owner</th>
          <th>{{ data.taxType }} Amount</th>
        </tr>
      </thead>
      <tbody>
        @for (row of eligible; track row.ownerStmtId) {
          <tr>
            <td>{{ row.propertyCode }}</td>
            <td>{{ row.ownerName }}</td>
            <td class="amount">{{ getAmount(row) | currency }}</td>
          </tr>
        }
        <tr class="total-row">
          <td colspan="2"><strong>Total</strong></td>
          <td class="amount"><strong>{{ totalAmount | currency }}</strong></td>
        </tr>
      </tbody>
    </table>

    <!-- Error -->
    @if (errorMsg) {
      <p class="error-msg">{{ errorMsg }}</p>
    }

    <!-- Success -->
    @if (submitted) {
      <div class="success-banner">
        Batch #{{ generatedBatchId }} marked as Submitted.
      </div>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>

  @if (eligible.length > 0 && !submitted) {
    <button mat-raised-button color="primary"
            [disabled]="generating || fileGenerated"
            (click)="generateFile()">
      @if (generating) { Generating... } @else if (fileGenerated) { File Downloaded } @else { Generate File }
    </button>

    @if (fileGenerated && generatedBatchId) {
      <button mat-raised-button color="accent"
              [disabled]="markingSubmitted"
              (click)="markSubmitted()">
        @if (markingSubmitted) { Saving... } @else { Mark as Submitted }
      </button>
    }
  }
</mat-dialog-actions>
